const debounce = (func, delay) => {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => func.apply(this, args), delay);
    };
};

const isMobileView = () => window.innerWidth <= 768;
const sidebar = $('.sidebar');
const sidebarToggler = $('.sidebar-toggler');
const collapsedClass = 'collapsed';
const csrfToken = $('meta[name="csrf-token"]').attr('content');

const saveSidebarState = debounce((isCollapsed) => {
    $.post('/save-preferences', {
        sidebarState: isCollapsed ? collapsedClass : '',
        _token: csrfToken,
    });
}, 300);

const initializeTooltips = (() => {
    let lastState = null;

    return (showTooltips) => {
        if (lastState === showTooltips) return;
        lastState = showTooltips;

        const tooltipTriggerList = document.querySelectorAll('.sidebar [data-bs-toggle="tooltip"]');
        tooltipTriggerList.forEach((tooltipTriggerEl) => {
            const tooltipInstance = Tooltip.getInstance(tooltipTriggerEl);
            if (tooltipInstance) {
                tooltipInstance.dispose();
            }
            if (showTooltips) {
                new Tooltip(tooltipTriggerEl);
            }
        });
    };
})();

const setupSidebarTooltips = () => {
    $('.sidebar .nav-link').attr({
        'data-bs-toggle': 'tooltip',
        'data-bs-placement': 'right',
        'data-bs-custom-class': 'sidebar-tooltip',
    });
};

const handleSidebarToggle = () => {
    const isCollapsed = sidebar.toggleClass(collapsedClass).hasClass(collapsedClass);
    localStorage.setItem('sidebarState', isCollapsed ? collapsedClass : '');
    saveSidebarState(isCollapsed);
    initializeTooltips(isCollapsed && !isMobileView());
};

const handleWindowResize = debounce(() => {
    const isCollapsed = sidebar.hasClass(collapsedClass);
    initializeTooltips(isCollapsed && !isMobileView());
}, 200);

export const initSidebar = () => {
    setupSidebarTooltips();

    $(window).on('resize', handleWindowResize);
    sidebarToggler.on('click', handleSidebarToggle);

    initializeTooltips(sidebar.hasClass(collapsedClass) && !isMobileView());
};
